import type { TOC } from '@ember/component/template-only';
import { hash } from '@ember/helper';
import type { WithBoundArgs as WBA } from '@glint/template';
import ChangesetBasicRadio, {
  type S as ChangesetBasicRadioSig
} from '../basic-radio.gts';
import ChangesetBasicRadioGroupFieldRadio from './field-radio.gts';
import ChangesetBasicRadioGroupWrappedRadio from './wrapped-radio.gts';

export interface S {
  Args: Pick<
    ChangesetBasicRadioSig['Args'],
    'translationKey' | 'changeset' | 'propertyName' | 'isReadOnly' | 'disabled'
  >;
  Blocks: {
    default: [
      {
        Radio: WBA<
          typeof ChangesetBasicRadio,
          | 'translationKey'
          | 'changeset'
          | 'propertyName'
          | 'isReadOnly'
          | 'disabled'
        >;
        WrappedRadio: WBA<
          typeof ChangesetBasicRadioGroupWrappedRadio,
          | 'translationKey'
          | 'changeset'
          | 'propertyName'
          | 'isReadOnly'
          | 'disabled'
        >;
        FieldRadio: WBA<
          typeof ChangesetBasicRadioGroupFieldRadio,
          | 'translationKey'
          | 'changeset'
          | 'propertyName'
          | 'isReadOnly'
          | 'disabled'
        >;
      }
    ];
  };
}

const ChangesetBasicRadioGroupRadioProvider: TOC<S> = <template>
  {{yield
    (hash
      Radio=(component
        ChangesetBasicRadio
        translationKey=@translationKey
        changeset=@changeset
        propertyName=@propertyName
        isReadOnly=@isReadOnly
        disabled=@disabled
      )
      WrappedRadio=(component
        ChangesetBasicRadioGroupWrappedRadio
        translationKey=@translationKey
        changeset=@changeset
        propertyName=@propertyName
        isReadOnly=@isReadOnly
        disabled=@disabled
      )
      FieldRadio=(component
        ChangesetBasicRadioGroupFieldRadio
        translationKey=@translationKey
        changeset=@changeset
        propertyName=@propertyName
        isReadOnly=@isReadOnly
        disabled=@disabled
      )
    )
  }}
</template>;

export default ChangesetBasicRadioGroupRadioProvider;
